import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IAuditDto } from '../../../../models/IAuditDto';
import { IAuditLighthouseDbConnectionDto } from '../../../../models/IAuditLighthouseDbConnectionDto';
import { IAuditLogEntryReferenceDto } from '../../../../models/IAuditLogEntryReferenceDto';
import { IAuditLogEntryRollupDto } from '../../../../models/IAuditLogEntryRollupDto';
import { IAuditLogEntryTimelineDto } from '../../../../models/IAuditLogEntryTimelineDto';
import { LighthouseDashboardService } from '../../../../services/lighthouse-dashbaord/lighthouse-dashboard.service';
import { BaseComponent } from '../../../base/base.component';
import { HeaderService } from 'src/app/services/_app/header/header.service';

@Component({
  selector: 'lighthouse-dashboard',
  templateUrl: './lighthouse-dashboard.component.html',
  styleUrls: ['./lighthouse-dashboard.component.css']
})
export class LighthouseDashboardComponent extends BaseComponent {

  all: boolean = false;
  public isPreviewDataSelected: boolean = false;
  skeleton: boolean = true;
  sortedColumn: string = '';
  sortAscending: boolean = true;

  constructor(private lighthouseDashboardService: LighthouseDashboardService,
    private headerService: HeaderService,
    private router: Router) {
    super();
    this.sortedColumn = 'tableName';
    this.sortAscending = false;
  }

  override async ngOnInit() {
    this.headerService.setSpinner(true);

    await this.getLogEntriesRollupAsync();

    let a = this.Audit;
    this.databaseName = a.DatabaseName;
  }

  public data: any[] = [];
  public data2: any[] = [];
  public data3: any[] = [];
  public databaseName: string = '...';
  public isGridShow: boolean = true;
  public tableName: string = '';

  public totalAuditEvents: number = 0;
  public totalInsertions: number = 0;
  public totalUpdates: number = 0;
  public totalDeletions: number = 0;

  public gotoDataExplorer() {
    this.router.navigate(['/lighthouse-data-explorer']);
  }

  private async getLogEntriesTimelineAsync() {
    let a: IAuditDto = this.Audit;

    await this.lighthouseDashboardService.getLogEntriesTimelineAsync(a.Id).then((x: Array<Array<IAuditLogEntryTimelineDto>>) => {
      this.data.map((a) => {
        let tableResults = x.filter((b) => b[0].SourceAuditTable === a.tableName);
        tableResults.map((b) => {
          b.filter((c) => {
            switch (c.AuditType) {
              case 'I':
                a.insertions = c.AuditTypeCount;
                this.totalInsertions += (c.AuditTypeCount * 1);
                console.log(`Running inserts: ${this.totalInsertions}`);
                break;
              case 'U':
                a.updates = c.AuditTypeCount;
                this.totalUpdates += (c.AuditTypeCount * 1);
                break;
              case 'D':
                a.deletions = c.AuditTypeCount;
                this.totalDeletions += (c.AuditTypeCount * 1);
                break;
            }
          });
        });
      });
      console.log(`Final inserts: ${this.totalInsertions}`);
      this.skeleton = false;
      this.headerService.setSpinner(false);
    }).catch((err: any) => {
      console.log(err);
      this.skeleton = false;
      this.headerService.setSpinner(false);
    });
  }

  private async getLogEntriesRollupAsync() {
    let a: IAuditDto = this.Audit;

    await this.lighthouseDashboardService.getLogEntriesRollupAsync(a.Id).then(async (x: Array<IAuditLogEntryRollupDto>) => {
      x.map((a: any) => {
        this.totalAuditEvents += a.TableRecordCount;

        this.data.push({
          tableSchema: a.SourceAuditSchema,
          tableName: a.SourceAuditTable,
          totalEvents: a.TableRecordCount,
          lastEvent: a.LastUpdated,
          insertions: a.InsertCount,
          updates: a.UpdateCount,
          deletions: a.DeleteCount,
          selected: false
        });

        this.totalInsertions += (a.InsertCount * 1);
        this.totalUpdates += (a.UpdateCount * 1);
        this.totalDeletions += (a.DeleteCount * 1);
      });

      this.skeleton = false;
      this.headerService.setSpinner(false);

      //await this.getLogEntriesTimelineAsync();
    }).catch((err: any) => {
      console.log(err);
      this.skeleton = false;
      this.headerService.setSpinner(false);
    });
  }

  private async getLogEntriesAsync() {
    //let _: IAuditLighthouseDbConnectionDto = {} as IAuditLighthouseDbConnectionDto;
    //_.ConnectionString = 'Server=localhost;Initial Catalog=homeazzon-local;Integrated Security=True;TrustServerCertificate=True;Connection Timeout=30;';
    //_.AuditDatabaseName = 'SampleDB_Audit';

    //await this.lighthouseDashboardService.getLogEntriesAsync(_).then((x: Array<IAuditLogEntryRollupDto>) => {
    //  x.map((a) => {
    //    this.data.push({
    //      tableSchema: a.SourceAuditSchema,
    //      tableName: a.SourceAuditTable,
    //      totalEvents: a.TableRecordCount,
    //      lastEvent: a.LastUpdated,
    //      insertions: 0,
    //      updates: 0,
    //      deletions: 0,
    //      selected: false
    //    });
    //  });
    //  this.headerService.setSpinner(false);
    //}).catch((err: any) => {
    //  console.log(err);
    //  this.headerService.setSpinner(false);
    //});
  }



  girdData() {
    this.isGridShow = true;
  }

  girdDataEmpty() {
    this.isGridShow = false;
  }

  close(event: boolean) {
    this.isPreviewDataSelected = false;
  }

  async showTableData(record: any) {
    this.PreviewDataTableSchema = record.tableSchema;
    this.PreviewDataTableName = record.tableName;
    this.isPreviewDataSelected = true;
  }

  sortByColumn(columnName: string): void {
    if (this.sortedColumn === columnName) {
      this.sortAscending = !this.sortAscending;
    } else {
      this.sortedColumn = columnName;
      this.sortAscending = true;
    }
    this.data.sort((a, b) => {
      if (a[columnName] < b[columnName]) return this.sortAscending ? -1 : 1;
      if (a[columnName] > b[columnName]) return this.sortAscending ? 1 : -1;
      return 0;
    });
  }
}
